/** @jsx jsx */

import { Dropdown, Spacer, Text } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import { LayoutStyles } from './constants';
import { ReactNode } from 'react';

export type BaseItem = {
  label: any;
  value: any;
};

const Styles = {
  heading: css`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 30px;
  `,
  filter: css`
    width: 210px;
  `,
  title: css`
    display: flex;
    align-items: center;
  `,
};

const managerStyle = css`
  max-width: none;
  padding: ${LayoutStyles.verticalPadding} ${LayoutStyles.horizontalPadding};
`;

type Props = {
  appId: string;
  children: ReactNode;
  items: Array<BaseItem>;
  onChooseFilter: (choice: BaseItem) => void;
  selectedFilter: BaseItem;
  tag?: ReactNode;
  title: string;
};

const FilterManagerLayout = ({
  title,
  tag,
  items,
  onChooseFilter,
  selectedFilter,
  children,
}: Props) => {
  return (
    <main css={managerStyle}>
      <header css={Styles.heading}>
        <div>
          <div css={Styles.title}>
            <Text fontWeight={600} tag="h1" type="PageHeader">
              {title}
            </Text>
            <Spacer width={10} />
            {tag && tag}
          </div>
        </div>
        <div css={Styles.filter}>
          <Dropdown
            items={items}
            menuAriaLabel={`Filter ${title.split(' ')[0]}`}
            onChange={onChooseFilter}
            placeholder="View"
            selectedItem={selectedFilter}
          />
        </div>
      </header>
      {children}
    </main>
  );
};

export default FilterManagerLayout;
